import { DemoFeatureKey } from './types';

export const DEMO_BASENAME = '/demo';

// True when the app is running in the demo (magic-link) zone. Computed once from
// the URL at load: the whole app is served under /demo via the router basename,
// so navigation stays in /demo and API calls authenticate with the demo cookie
// instead of PropelAuth. A tab is either normal or demo — logging in opens a new
// (normal) tab.
const path = typeof window !== 'undefined' ? window.location.pathname : '';
export const isDemoZone = path === DEMO_BASENAME || path.startsWith(`${DEMO_BASENAME}/`);

// Demo feature key → the route the prospect lands on (resolved under the /demo
// basename). Add a key here to expose a new feature to demos.
export const DEMO_FEATURE_ROUTE_PREFIX: Record<DemoFeatureKey, string> = {
  'dashboard:project_screener': '/project-screener',
};
